import { Partition } from '@snapchat/graphene';

import { snapSiteConfigTheme } from '../../brands/snap/snapBrandConfigSharedSettings';
import { Feature } from '../../components/FeatureFlags';
import type { SiteConfiguration } from '../../configTypes';
import { LoggingVendor } from '../../helpers/logging/eventListenerTypes';

export const config: SiteConfiguration = {
  domainName: 'snap.com',

  featureFlags: {
    [Feature.USE_SNAP_MOTIF]: 'true',
  },

  theme: snapSiteConfigTheme,
  trackingSettings: {
    eventListeners: [
      { vendor: LoggingVendor.BLIZZARD },
      { vendor: LoggingVendor.CONSOLE },
      { vendor: LoggingVendor.GOOGLE_CLOUD_LOGGING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_MONITORING },
      { vendor: LoggingVendor.GOOGLE_CLOUD_ERROR_REPORTING },
      { vendor: LoggingVendor.GRAPHENE, partitionName: Partition.SNAP_WEB },
      {
        vendor: LoggingVendor.GOOGLE_TAG_MANAGER,
        googleTagManagerId: 'GTM-PB72WQ3',
        googleAnalyticsId: 'G-LJY98QLWYT',
      },
      {
        vendor: LoggingVendor.SENTRY,
        projectName: 'snap',
        dsn: 'https://fdd828e30c9c423cb0653ae452415f77@sentry.sc-prod.net/81',
      },
    ],
  },
  csp: [
    // Newsroom block integration
    {
      connectSrc: ['https://newsroom.snap.com'],
    },
  ],
};
